<mat-card class="cardWithShadow w-50">
    <mat-card-content>
      <div>
        <h3>Factorizaciones por factoring</h3>
      </div>
  
      <div class="table-responsive m-t-30">
        <table
          mat-table
          [dataSource]="dataSource"
          class="w-100"
          matSort
          matSortDirection="asc"
        >
          <!-- Position Column -->
          <ng-container matColumnDef="cesionarioName">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="th-title"
            >
              Nombre Cliente
            </th>
            <td mat-cell *matCellDef="let element">
              <h6>
                {{ element.cesionarioName }}
              </h6>
            </td>
          </ng-container>
  
          <!-- Name Column -->
          <ng-container matColumnDef="cesionarioRut">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef
              class="th-title"
            >
              Rut
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>
                {{ element.cesionarioRut }}
              </h6>
            </td>
          </ng-container>
  
          <!-- Weight Column -->
          <ng-container matColumnDef="transferedInvoiceTotalAmount">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef
              class="th-title"
            >
              Monto Facturas
            </th>
            <td mat-cell *matCellDef="let element">
              <h6>${{ element.transferedInvoiceTotalAmount | number }}</h6>
            </td>
          </ng-container>
  
          <!-- Symbol Column -->
          <ng-container matColumnDef="numTransferedInvoices">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef
              class="th-title"
            >
              Documentos
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.numTransferedInvoices }}</h6>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
          <!-- Row shown when there is no matching data. -->
          <!-- <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                No data matching the filter "{{ input.value }}"
              </td>
            </tr> -->
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
  